import {ChevronDownIcon, ChevronUpIcon} from '@primer/octicons-react'
import {ButtonGroup, IconButton} from '@primer/react'
import {useDiffNavigation} from '../../hooks/use-diff-navigation'
import {SingleFileModeOnboardingPopover} from './SingleFileModeOnboardingPopover'
import {areCharacterKeyShortcutsEnabled} from '@github-ui/hotkey/keyboard-shortcuts-helper'
import type {FilesPageNotices, UserNotice} from '../../page-data/payloads/files'

type ReviewNavigationButtonGroupProps = {
  userNotices?: Array<UserNotice<FilesPageNotices>>
}

export function ReviewNavigationButtonGroup({userNotices}: ReviewNavigationButtonGroupProps) {
  const areShortcutsEnabled = areCharacterKeyShortcutsEnabled()
  const {navigateToPrevious, navigateToNext} = useDiffNavigation()

  const previousLabel = areShortcutsEnabled ? 'Previous file (K)' : 'Previous file'
  const nextLabel = areShortcutsEnabled ? 'Next file (J)' : 'Next file'
  return (
    <div className="position-relative">
      <ButtonGroup>
        <IconButton
          icon={ChevronUpIcon}
          aria-label={previousLabel}
          size="small"
          onClick={navigateToPrevious}
          data-hotkey="k"
        />
        <IconButton
          icon={ChevronDownIcon}
          aria-label={nextLabel}
          size="small"
          onClick={navigateToNext}
          data-hotkey="j"
        />
      </ButtonGroup>
      <SingleFileModeOnboardingPopover userNotices={userNotices} />
    </div>
  )
}

try{ ReviewNavigationButtonGroup.displayName ||= 'ReviewNavigationButtonGroup' } catch {}